export default {
  formTitle: 'Sign in to your account',
  emailPlaceholder: 'Enter your Email',
  passwordPlaceholder: 'Enter your Password',
  submitButton: 'Log In',
  forgotPasswordLink: 'Forgot password?',
};
